import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import cardReducer from './slices/card';
import rarityReducer from './slices/rarity';

const rootPersistConfig = {
  key: 'root',
  storage,
  // keyPrefix: 'redux-',
  // whitelist: [],
};

const rootReducer = combineReducers({
  card: cardReducer,
  rarity: rarityReducer,
});

export { rootPersistConfig, rootReducer };
